import React from 'react';

const Profile: React.FC = () => {
  return (
    <div className="space-y-4">
      <h1 className="text-3xl font-semibold text-gray-900">Profile</h1>
      <p className="text-base text-gray-600">
        Manage your personal details and keep your contact information up to date. Enhanced profile controls will be
        available in a subsequent release.
      </p>
    </div>
  );
};

export default Profile;
